/*
  DogPure · recomendaciones del carrito lateral.
  - <dp-cart-upsell>: «Complementa tu compra». Añade la variante con /cart/add.js.
  - <dp-cart-upgrade>: «Lleva 2 frascos». Cambia la línea existente a N unidades con /cart/change.js
    (misma línea, sin duplicados; conserva sus propiedades y actualiza «Bundle» si la tenía).
  En ambos casos se piden en la misma respuesta las secciones del carrito y del contador; el carrito nativo de
  Dawn (cart-drawer.js) las pinta. Precios, descuentos, envío y totales: siempre los devuelve Shopify.
  Mientras el carrito se recalcula (estas acciones o las cantidades de Dawn) no se puede continuar al pago.
*/
const dpCartItems = () => document.getElementById('CartDrawer-CartItems');
const dpCartBusy = () => dpCartItems()?.classList.contains('cart__items--disabled');

function dpCartRequest(element, url, payload) {
  const drawer = document.querySelector('cart-drawer');
  const button = element.querySelector('button');
  const error = element.querySelector('[role="alert"]');
  if (!drawer || !button || button.getAttribute('aria-disabled') === 'true' || dpCartBusy()) return;

  button.setAttribute('aria-disabled', 'true');
  button.classList.add('loading');
  button.querySelector('.loading__spinner')?.classList.remove('hidden');
  if (error) error.hidden = true;
  dpCartItems()?.classList.add('cart__items--disabled');

  const sections = drawer.getSectionsToRender().map((section) => section.id);
  const body = JSON.stringify({ ...payload, sections, sections_url: window.location.pathname });

  fetch(url, { ...fetchConfig('json'), body })
    .then((response) => response.json())
    .then((state) => {
      if (state.status || !state.sections) throw new Error(state.description || state.message);
      // Sin publicar cartUpdate: el carrito lateral volvería a pedir y pintar las mismas secciones
      // y se perdería el foco.
      drawer.renderContents(state);
      requestAnimationFrame(() => {
        const container = document.getElementById('CartDrawer');
        const first = container?.querySelector('.cart-item__name');
        if (container && first) trapFocus(container, first);
      });
    })
    .catch(() => {
      dpCartItems()?.classList.remove('cart__items--disabled');
      if (error) error.hidden = false;
      button.removeAttribute('aria-disabled');
      button.classList.remove('loading');
      button.querySelector('.loading__spinner')?.classList.add('hidden');
    });
}

if (!customElements.get('dp-cart-upsell')) {
  customElements.define(
    'dp-cart-upsell',
    class DpCartUpsell extends HTMLElement {
      connectedCallback() {
        this.querySelector('[data-upsell-add]')?.addEventListener('click', () =>
          dpCartRequest(this, routes.cart_add_url, { items: [{ id: Number(this.dataset.variantId), quantity: 1 }] })
        );
      }
    }
  );
}

if (!customElements.get('dp-cart-upgrade')) {
  customElements.define(
    'dp-cart-upgrade',
    class DpCartUpgrade extends HTMLElement {
      connectedCallback() {
        this.querySelector('[data-upgrade]')?.addEventListener('click', () => this.upgrade());
      }

      upgrade() {
        const payload = { id: this.dataset.lineKey, quantity: Number(this.dataset.quantity) };
        // change.js sustituye todas las propiedades: se envían las de la línea con «Bundle» actualizado
        const source = this.querySelector('[data-properties]');
        if (source && this.dataset.bundle) {
          try {
            // Liquid serializa item.properties como pares [clave, valor]
            const parsed = JSON.parse(source.textContent);
            const current = Array.isArray(parsed) ? Object.fromEntries(parsed) : parsed;
            payload.properties = { ...current, Bundle: this.dataset.bundle };
          } catch (e) {
            // Sin propiedades legibles se cambia solo la cantidad
          }
        }
        dpCartRequest(this, routes.cart_change_url, payload);
      }
    }
  );
}

/* Continuar al pago solo con importes ya recalculados por Shopify */
(() => {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;
  const sync = () => {
    const button = document.getElementById('CartDrawer-Checkout');
    if (!button || drawer.classList.contains('is-empty')) return;
    const busy = dpCartBusy();
    if (busy) {
      button.setAttribute('disabled', '');
      button.dataset.dpBusy = 'true';
    } else if (button.dataset.dpBusy) {
      button.removeAttribute('disabled');
      delete button.dataset.dpBusy;
    }
  };
  new MutationObserver(sync).observe(drawer, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
})();
